import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";
Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        user: {
            namespaced: true,
            state: () => ({
                loginfo: '',
                information: null,
                email: '',
                hostname: '',
                new_message: 0,
                new_message_inbox: 0,
                new_notification: 0,
                notregistered: false,
                max_loa: null,
                services: {
                    meetings: {
                        enabled: true,
                        jitsi: false,
                        teams: false,
                        jitsi_confidential: false,
                        jitsi_confidential_body_enabled: false,
                        jitsi_confidential_subject_enabled: false,
                        jitsi_confidential_body: "",
                        jitsi_confidential_subject: ""
                    }
                },
                notification_text: '',
                functionboxes: null,
                delegatedboxes: null,
                redirect_url: '',
                version: '',
                external_loa_levels: null,
                loa_level_enabled: null,
                message_response_default: 1,
                message_response_enabled: 1,
                email_information_text: '',
                email_edit_information_text:1,
                accounts_can_delegate: 0,
                loa_default_level: 0,
                auth_loa: 2,
                ticket: null,
                token: "",
                new_files: 0,
                drafts: 0,
                notifications: 0
            }),
            getters: {
                loginfo: state => state.loginfo,
                services: state => state.services,
                information: state => state.information,
                email: state => state.email,
                hostname: state => state.hostname,
                new_message: state => state.new_message,
                new_message_inbox: state => state.new_message_inbox,
                new_notification: state => state.new_notification,
                authenticated: state => state.information !== null,                
                max_loa: state => state.max_loa,
                notregistered: state => state.notregistered,
                redirect_url: state => state.redirect_url,
                functionboxes: state => state.functionboxes,
                delegatedboxes: state => state.delegatedboxes,
                version: state => state.version,
                external_loa_levels: state => state.external_loa_levels,
                loa_level_texts: state => state.loa_level_texts,
                loa_level_enabled: state => state.loa_level_enabled,
                message_response_default: state => state.message_response_default,
                message_response_enabled: state => state.message_response_enabled,
                email_edit_information_text: state => state.email_edit_information_text,
                email_information_text: state => state.email_information_text,
                accounts_can_delegate: state => state.accounts_can_delegate,
                loa_default_level: state => state.loa_default_level,
                auth_loa: state => state.auth_loa,
                ticket: state => state.ticket,
                token: state => state.token,
                new_files: state => state.new_files,
                drafts: state => state.drafts,
                notifications: state => state.notifications,
                notification_text: state => state.notification_text
            },
            mutations: {
                ["FETCH_USER_SUCCESS"](state, { data }) {
                    state.information = data.user;
                    state.new_message = data.new_message;    
                    if(data.auth_loa != undefined)
                    {
                        state.auth_loa = data.auth_loa;
                    }                
                    if(data.max_loa != undefined){
                        state.max_loa = data.max_loa;
                    }else{
                        state.max_loa = {
                            login: 3,
                            external: 3
                        };
                    }
                    if(data.new_message_inbox != undefined)
                    {
                        state.new_message_inbox = data.new_message_inbox;
                    }
                    if(data.new_notification != undefined)
                    {
                        state.new_notification = data.new_notification;
                    }
                    if(data.loa_default_level != undefined)
                    {
                        state.loa_default_level = data.loa_default_level;
                    }
                    if(data.functionboxes != undefined){
                        state.functionboxes = data.functionboxes;
                    }
                    if(data.delegatedboxes != undefined){
                        state.delegatedboxes = data.delegatedboxes;
                    }
                    if(data.services != undefined){
                        if(data.services.meetings.jitsi_confidential == undefined){
                            state.services.meetings = data.services.meetings;
                            state.services.meetings.jitsi_confidential = false;
                            state.services.meetings.jitsi_confidential_body = "";
                            state.services.meetings.jitsi_confidential_subject = "";
                            state.services.meetings.jitsi_confidential_body_enabled = false;
                            state.services.meetings.jitsi_confidential_subject_enabled = false;
                        }else{
                            state.services = data.services;
                        }
                    }
                    if(data.external_loa_levels != undefined){
                        state.external_loa_levels = data.external_loa_levels;
                    }else{
                        state.external_loa_levels = {
                            loa3: 1,
                            loa2: 1,
                            loa1: 1
                        }
                    }                    
                    if(data.loa_level_texts != undefined){
                        state.loa_level_texts = data.loa_level_texts;
                    }
                    if(data.loa_level_enabled != undefined)
                    {
                        state.loa_level_enabled = data.loa_level_enabled;
                    }else{
                        state.loa_level_enabled = {
                            loa1_enabled: 1,
                            loa2_enabled: 1,
                            loa3_enabled: 1
                        }
                    }
                    if(data.message_response_default != undefined){
                        state.message_response_default = data.message_response_default;
                    }
                    if(data.message_response_enabled != undefined){
                        state.message_response_enabled = data.message_response_enabled;
                    }
                    if(data.email_information_text != undefined){
                        state.email_information_text = data.email_information_text;
                    }
                    if(data.email_edit_information_text != undefined){
                        state.email_edit_information_text = data.email_edit_information_text;
                    }
                    if(data.accounts_can_delegate != undefined){
                        state.accounts_can_delegate = data.accounts_can_delegate;
                    }
                    if(data.drafts != undefined){
                        state.drafts = data.drafts;
                    }
                    if (data.notifications != undefined) {
                        state.notifications = data.notifications;
                    }
                    if(data.ticket != undefined)
                    {
                        state.ticket = data.ticket;
                    }else{
                        state.ticket = {
                            auth_type: "",
                            auth_method: "",
                            loa_level: state.auth_loa,
                            sdk_enabled: 0
                        };
                    }
                },
                ["USER_SET_HOSTNAME"](state, payload) {
                    state.notregistered = false;
                    state.hostname = payload;
                },
                ["USER_SET_TOKEN"](state, token) {
                    state.token = token;
                },
                ["USER_ADD_LOG"](state, payload) {
                    state.loginfo = state.loginfo + "\n" + payload;
                },
                ["USER_SET_EMAIL"](state, payload) {
                    state.email = payload;
                },
                ["USER_SET_NOTIFICATION"](state, payload) {
                    state.notification_text = payload;
                },
                ["USER_SET_VERSION"](state, payload) {
                    if( payload.split(".").length == 2)
                    {
                        state.version = payload + ".0";
                    }else{
                        state.version = payload;
                    }
                },
                ["LOGOUT"](state) {
                    state.information = null;
                },
                ["USER_SET_REDIRECT"](state, { redirect_url }) {
                    state.redirect_url = redirect_url;
                },
                ["FETCH_HOSTNAME_FAILURE"](state) {
                    state.notregistered = true;
                    state.information = null;
                    state.hostname = "";
                },
                ["FETCH_USER_FAILURE"](state) {
                    state.information = null;                
                }
            },
            actions: {
                async fetchFiles({ commit, state }) {
                    try {
                        let response = await axios.post(state.hostname + "/filestorage/new/list",
                        {
                            organisation_uuid: state.information.organisation.organisation_uuid
                        });
                        let files = response.data;
                        commit("USER_SET_FILES", { files });
                    } catch (e) {
                        commit("USER_SET_FILES", 0);
                    }
                },
                async setRedirectUrl({ commit }, redirect_url) {
                    commit("USER_SET_REDIRECT", { redirect_url });
                },
                async logInfo({ commit }, information) {
                    commit("USER_ADD_LOG", information);
                },
                async setToken({ commit }, token) {
                    if(token != undefined && token != null && token != "")
                    {
                        await this.dispatch("user/logInfo", "setting token");
                        commit("USER_SET_TOKEN", token);
                        localStorage.setItem("token", token);
                    }
                },
                async setEmail({ commit }, email) {
                    if (process.env.VUE_APP_EMAIL !== "") {
                        await this.dispatch("user/logInfo", "setting email " + process.env.VUE_APP_EMAIL);
                        commit("USER_SET_EMAIL", process.env.VUE_APP_EMAIL);
                    } else {
                        await this.dispatch("user/logInfo", "setting email " + email);
                        commit("USER_SET_EMAIL", email);
                    }
                },
                async fetchVersion({ commit, state }) {
                    if (state.hostname != "") {
                        try {
                            const { data } = await axios.get(state.hostname + "/version"); 
                            await this.dispatch("user/logInfo", "setting version " + data);         
                            commit("USER_SET_VERSION", data);
                        } catch (e) {
                            commit("USER_SET_VERSION","");
                        }
                    }
                },
                async fetchNotificationText({ commit, state }) {
                    if (state.hostname != "") {
                        try {
                            const { data } = await axios.get(state.hostname + "/notify-information"); 
                            await this.dispatch("user/logInfo", "getting notification text");         
                            commit("USER_SET_NOTIFICATION", data);
                        } catch (e) {
                            commit("USER_SET_NOTIFICATION","");
                        }
                    }
                },
                async fetchHostname({ commit, state }) {
                    if (process.env.VUE_APP_SERVER !== "") {
                        await this.dispatch("user/logInfo", "setting hostname " + process.env.VUE_APP_SERVER );    
                        commit("USER_SET_HOSTNAME", process.env.VUE_APP_SERVER);
                        return "";
                    } else {
                        if( (state.hostname == '') && (state.email != "") ) {                            
                            await this.dispatch("user/logInfo", "no email - no hostname" );    
                            try {
                                const result = await axios.post(process.env.VUE_APP_GLOBAL_URL + "/email/whereami", {
                                    email: state.email
                                });
                                await this.dispatch("user/logInfo", "setting hostname " + result.data.hostname );    
                                commit("USER_SET_HOSTNAME", result.data.hostname + "/server/rest");
                                return true;
                            } catch (e) {
                                await this.dispatch("user/logInfo", "Could not fetch hostname " + e);     
                                commit("FETCH_HOSTNAME_FAILURE", '');
                                return true;
                            }
                        }
                    }
                },
                async fetchUser({ commit, state }) {                    
                    await this.dispatch("user/logInfo", "fetchUser");
                    if ( (state.email != "") && (state.hostname != "") ) {
                        try {
                            const { data } = await axios.get(state.hostname + "/isLoggedin");
                            await this.dispatch("user/logInfo", "data");
                            if(data.token != undefined)
                            {
                                await this.dispatch("user/logInfo", "data.token found");
                                await this.dispatch("user/setToken", data.token);
                                if(localStorage)
                                {
                                    localStorage.setItem("token", data.token);
                                }
                            }
                            await this.dispatch("user/logInfo", "fetchUser success");
                            commit("FETCH_USER_SUCCESS", { data }); 
                            await this.dispatch("user/fetchNotificationText");
                            return true;
                        } catch (e) {
                            await this.dispatch("user/logInfo", "fetchUser failed");
                            commit("FETCH_USER_FAILURE");
                            return true;
                        }
                    }
                },
                async NotAuthenticated({ commit }) { 
                    localStorage.removeItem("token");
                    commit("LOGOUT");
                }
            }
        },
        lang: {
            namespaced: true,
            state: ({
                locales: {
                    'en': 'English'
                    ,'sv': 'Svenska'
                    ,'nb': 'Norsk'
                }
            }),
            getters: {
                locales: state => state.locales,
                showAuth: state => state.auth
            },
            mutations: {
                ['LOCALE_SET'](state, payload) {
                    state.locale = payload.locale;
                }
            },
            actions: {
                setLocale({ commit }, locale) {
                    commit('LOCALE_SET', { locale: locale });
                }

            }
        },
        teams: {
            namespaced: true,
            state: ({
                name: 'Teams',
                context: null,
                theme: 'theme-default',
                authenticated: false
            }),
            getters: {
                context: state => state.context,
                theme: state => state.theme,
                name: state => state.name,
                authenticated: state => state.authenticated
            },
            mutations: {
                ["TEAMS_SET_CONTEXT"](state, { context }) {
                    state.name = "Teams";
                    if(context.app.host.name == "office" || context.app.host.name == "Office")
                    {
                        state.name = "Office";
                    }
                    if(context.app.host.name == "outlook" || context.app.host.name == "outlookWin32" || context.app.host.name == "Outlook" || context.app.host.name == "OutlookWin32")
                    {
                        state.name = "Outlook";
                    }
                    if(context.app.theme == "dark" || context.app.theme == "highcontrast")
                    {
                        document.body.style.background = "#000";
                    }
                    state.theme = "theme-" + context.app.theme;  
                    state.context = context;
                },
                ["TEAMS_SET_AUTHENTICATED"](state, { authenticated }) {
                    state.authenticated = authenticated;
                },
                ["TEAMS_SET_NAME"](state, { name }) {
                    state.name = name;
                }
            },
            actions: {
                async context({ commit }, context) {
                    await this.dispatch("user/logInfo", "setting context ");   
                    commit('TEAMS_SET_CONTEXT', { context: context });
                },
                async authenticated({ commit }, authenticated) {
                    await this.dispatch("user/logInfo", "teams authenticated ");   
                    commit('TEAMS_SET_AUTHENTICATED', { authenticated: authenticated });
                }
            }
        },
        errors: {
            namespaced: true,
            state: ({
                validations: []
            }),
            getters: {
                validations: state => state.validations
            },
            mutations: {
                ['ADD_VALIDATIONS'](state, { validations }) {
                    state.validations = state.validations.concat(validations.filter(v => !state.validations.some(sv => sv.status === v.status)))
                },
                ['REMOVE_VALIDATIONS'](state) {
                    state.validations = []
                }
            },
            actions: {
                addValidations({ commit }, validations) {
                    commit('ADD_VALIDATIONS', { validations });
                },
                removeValidations({ commit }) {
                    commit('REMOVE_VALIDATIONS');
                }
            }
        }
    }
});